import { useViewer } from "@nexxt/app-kit";
import { createContext, type ReactNode, use } from "react";

// What the catalog screens need of the app besides the user (app-kit's ViewerProvider): the words of the fields the
// catalog does not name itself (ADR-166). The client is registered apart (client.ts), since the route loaders read
// through it outside React.

interface CatalogTexts {
  /** A field the catalog does not name (the missing code of another system): its words, or undefined. */
  fieldText: (field: string) => string | undefined;
}

const CatalogTextsContext = createContext<CatalogTexts | null>(null);

/** Optional: without it, a field the catalog does not name is shown as it is. */
export function CatalogTextsProvider({ value, children }: { value: CatalogTexts; children: ReactNode }) {
  return <CatalogTextsContext value={value}>{children}</CatalogTextsContext>;
}

/** The user of the screen, and the words of the app. */
export function useCatalogUi() {
  return { ...useViewer(), fieldText: use(CatalogTextsContext)?.fieldText };
}
